import { getInitialStateFromConfig } from "helpers/form";

export const config = {
    manualValues: {
        label: "Переопределенные значения",
        inputProps: { name: "manualValues", placeholder: '{"DocumentTag":"value"}' },
        textarea: true,
    },
};

export const initialState = getInitialStateFromConfig(config);
